module.exports = __webpack_public_path__ + "env.f07b3da.basis";